document.addEventListener("livewire:init", () => {
    Livewire.on('updatedBlogs', () => {
        setTimeout(() => document.dispatchEvent(new Event('resize')), 150);
    });
});
